module.exports = __webpack_public_path__ + "assets/devices/TOUCH_KP-b9315afaf497492877b35435b3ae83e4.svg";